import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import {
    RED,
    RED_BACKGROUND,
    SWEGON_GREEN,
    DARK_GREEN,
    PALE_GREEN
} from '@swegon-core/uic/dist/src/theme';

export const Toastr = styled(ToastContainer)`
    .Toastify__toast-theme--colored.Toastify__toast--success {
        background-color: ${PALE_GREEN};
        border-radius: 0;
        color: ${DARK_GREEN};

        .Toastify__close-button {
            color: ${DARK_GREEN};
        }

        .Toastify__progress-bar {
            background-color: ${SWEGON_GREEN};
        }
    }
    .Toastify__toast-theme--colored.Toastify__toast--error {
        background-color: ${RED_BACKGROUND};
        color: ${RED};

        .Toastify__close-button {
            color: ${RED};
        }

        .Toastify__progress-bar {
            background-color: ${RED};
        }
    }
`;
